import { yupResolver } from '@hookform/resolvers/yup'
import { DateOnly } from '@if/core/date'
import { DEFAULT_PAYMENT_METHOD } from '@src/types/constants'
import { nanoid } from 'nanoid'
import { useMemo } from 'react'
import { Resolver } from 'react-hook-form'
import { EditPaymentSchemaType, getEditPaymentSchema } from '../EditPayments-schema'

export const useAddPaymentSchema = (
  loanActivationDate: DateOnly,
  initialAmount?: number,
  canBypassAcpLock = false,
) => {
  return useMemo<{
    resolver: Resolver<EditPaymentSchemaType>
    defaultValues: EditPaymentSchemaType
  }>(() => {
    const paymentSchema = getEditPaymentSchema(loanActivationDate, canBypassAcpLock)
    return {
      resolver: yupResolver(paymentSchema),
      defaultValues: {
        ...(paymentSchema.getDefault() as unknown as EditPaymentSchemaType),
        paymentMethod: DEFAULT_PAYMENT_METHOD,
        sendSmsReminder: true,
        id: nanoid(),
        isLocked: false,
        isNew: true,
        isDeleted: false,
        amount: initialAmount ?? 0,
      },
    }
  }, [loanActivationDate, initialAmount, canBypassAcpLock])
}
